import React, { memo, useState } from 'react';
import Formsy from 'formsy-react';
import { Button, Col, Row, FormGroup, Label, SimpleAlert, SheetBody, SheetFooter } from 'twyne-new.ui';

import Select from 'components/form/Select';
import Switch from 'components/form/Switch';
import Inputy from 'components/form/Input';

import { fileTypesOptions, delimiterOptions, quotecharOptions, indentOptions } from './SweepContestFinishedForm/options'

class DownloadSubscribe extends React.Component {
  columns = [
    { label: "E-mail", value: "email" },
    { label: "E-mail MD5", value: "md5" },
    { label: "Submission Date", value: "created_at" }
  ]

  handleValidSubmit = model => {
    this.props.onSubmit(model);
  }

  CSVOptions = () => {
    return <>
      <Col size='6'>
        <FormGroup>
          <Label>Delimiter Char</Label>
          <Select
            name="delimiter"
            value='comma'
            options={delimiterOptions}
            clearable={false}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>Quote Char</Label>
          <Select
            name="quotechar"
            value='doublequote'
            options={quotecharOptions}
            clearable={false}
          />
        </FormGroup>
      </Col>
    </>
  }

  JSONOptions = () => {
    return <>
      <Col size='6'>
        <FormGroup>
          <Label>Indentation</Label>
          <Select
            name='indent'
            options={indentOptions}
            clearable={false}
          />
        </FormGroup>
      </Col>
    </>
  }

  FileOptions = ({ fileType }) => {

    if (fileType === 'csv')
      return <this.CSVOptions />

    if (fileType === 'json')
      return <this.JSONOptions />

    return null
  }

  Content = () => {
    const { columns } = this
    const [fileType, setFileType] = useState('csv')

    return <Formsy onValidSubmit={this.handleValidSubmit}>
      <SheetBody className='border-t-0'>
        <Row>
          <Col size='6'>
            <FormGroup>
              <Label>File name</Label>
              <Inputy required
                name="file_name"
                value='unsubscribes'
              />
            </FormGroup>
          </Col>
          <Col size='6'>
            <FormGroup>
              <Label>File type</Label>
              <Select
                name="file_type"
                value={fileType}
                options={fileTypesOptions}
                clearable={false}
                handleOnChange={({ value }) => setFileType(value)} />
            </FormGroup>
          </Col>
          <this.FileOptions fileType={fileType} />
          <Col>
            <FormGroup>
              <Label>Columns</Label>
              <Select required multi
                name="columns"
                value={[columns[1]]}
                validations={{ isRequired: (_, value) => value.length }}
                options={columns}
              />
            </FormGroup>
          </Col>
          {fileType === 'json' ? null : <Col>
            <FormGroup>
              <Label>Include headers</Label>
              <Switch name='header' />
            </FormGroup>
          </Col>}
          <Col>
            <SimpleAlert>Once your request has been processed, the unsubscribe file will be sent to your registered e-mail address.</SimpleAlert>
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button color='accent' type="submit">Request Download</Button>
      </SheetFooter>
    </Formsy>
  }

  render() {
    return <this.Content />
  }
}

export default memo(DownloadSubscribe)